import { render, staticRenderFns } from "./profile-section.vue?vue&type=template&id=70992ba5&scoped=true&"
import script from "./profile-section.vue?vue&type=script&lang=js&"
export * from "./profile-section.vue?vue&type=script&lang=js&"
import style0 from "./profile-section.vue?vue&type=style&index=0&id=70992ba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70992ba5",
  null
  
)

export default component.exports